import {
  type FC, type ReactNode,
} from 'react';
import { ModalComponent } from '~/_shared/components/modal/modal.component';
import { type ModalProps } from '~/modal/modalType.enum';

export type AdHocModalProps = ModalProps<{
  caption?: string;
  content: ReactNode | ((onClose: () => void) => ReactNode);
}>;

export const AdHocModalComponent: FC<AdHocModalProps> = ({ caption, content, isOpen, onClose }) => (
  <ModalComponent
    caption={caption}
    isOpen={isOpen}
    onClose={onClose}
  >
    {typeof content === 'function' ? content(onClose) : content}
  </ModalComponent>
);
